export enum Color {
  UI_TEXT_PRIMARY = 'UI_TEXT_PRIMARY',
  UI_TEXT_INVERTED = 'UI_TEXT_INVERTED',
  UI_FEEDBACK_SUCCESS = 'UI_FEEDBACK_SUCCESS'
}

type Text = {
  value: string
  color: Color
  style: string
}

export type GiftProps = {
  title: Text
  image: {
    url: string
  }
  tags: Tag[]
  quantity: number
}

type Tag = {
  text: string
  textColor: Color
  backgroundColor: Color
}
